
export const arraysMatch = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  arr1.sort();
  arr2.sort();
  return arr1.every((value, index) => value === arr2[index]);
}
